import { Flex, Pane, TableV2, Text } from '@leverege/ui-elements'
import React from 'react'
import useEventsTable from '../hooks/useEventsTable'
import S from './Tables.css'

function Tables( props ) {
  const { jobId, psData, ssData, bndData, columns } = useEventsTable( props )

  return (
    <Flex gap={14} variant="col" style={{ overflow : 'hidden', width : '100%' }}>
      <Text variant="expressionParen">Job ID: {jobId}</Text>
      <Pane
        variant="dashboardCardCustom"
        layout="flex:col"
        style={{ width : '100%' }}>
        <Pane
          variant="dashboardCardCustomBigHeader"
          style={{ paddingLeft : 16 }}>
          <Flex variant="rowSpaceBetween">
            <Text variant="tableHeader">SS Shell</Text>
          </Flex>
        </Pane>
        <div
          style={{
            padding : '0 16px 16px 16px',
          }}>
          <TableV2 className={S.table} variant="delayTable" data={ssData} columns={columns} sortable={false} />
        </div>
      </Pane>
      <Pane
        variant="dashboardCardCustom"
        layout="flex:col"
        style={{ width : '100%' }}>
        <Pane
          variant="dashboardCardCustomBigHeader"
          style={{ paddingLeft : 16 }}>
          <Flex variant="rowSpaceBetween">
            <Text variant="tableHeader">PS Shell</Text>
          </Flex>
        </Pane>
        <div
          style={{
            padding : '0 16px 16px 16px',
          }}>
          <TableV2 className={S.table} variant="delayTable" data={psData} columns={columns} sortable={false} />
        </div>
      </Pane>
      <Pane
        variant="dashboardCardCustom"
        layout="flex:col"
        style={{ width : '100%' }}>
        <Pane
          variant="dashboardCardCustomBigHeader"
          style={{ paddingLeft : 16 }}>
          <Flex variant="rowSpaceBetween">
            <Text variant="tableHeader">Bonded Blade</Text>
          </Flex>
        </Pane>
        <div
          style={{
            padding : '0 16px 16px 16px',
          }}>
          <TableV2 className={S.table} variant="delayTable" data={bndData} columns={columns} sortable={false} />
        </div>
      </Pane>
    </Flex>
  )
}

export default Tables
